import { Box, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { RevealView, StaggerItemView, StaggerView } from '../../common/motion';
import IntroCoverageCard from './IntroCoverageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroCoverageSection = function IntroCoverageSection() {
  /**
   * watch
   */
  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var coverageTitle = useWatch({
    control: control,
    name: 'coverageTitle'
  });
  var coverageSubtitle = useWatch({
    control: control,
    name: 'coverageSubtitle'
  });
  var coverageItems = useWatch({
    control: control,
    name: 'coverageItems'
  });
  var expertiseTitle = useWatch({
    control: control,
    name: 'expertiseTitle'
  });
  var expertiseChips = useWatch({
    control: control,
    name: 'expertiseChips'
  });
  var expertiseHidden = useWatch({
    control: control,
    name: 'expertiseHidden'
  });
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col items-center space-y-12 py-16 md:py-24",
    children: [/*#__PURE__*/_jsxs(RevealView, {
      className: "flex flex-col items-center space-y-4 text-center",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "font-['Playfair_Display',serif] text-3xl font-black leading-tight text-[#202020] md:text-[34px]",
        children: coverageTitle
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-base font-medium leading-7 text-[#474747] md:text-lg",
        children: coverageSubtitle
      })]
    }), /*#__PURE__*/_jsx(StaggerView, {
      className: "grid w-full grid-cols-1 gap-6 md:grid-cols-3",
      stagger: 0.08,
      children: coverageItems.map(function (item) {
        return /*#__PURE__*/_jsx(StaggerItemView, {
          distance: 28,
          children: /*#__PURE__*/_jsx(IntroCoverageCard, {
            item: item
          })
        }, item.title);
      })
    }), !expertiseHidden && /*#__PURE__*/_jsxs(RevealView, {
      className: "flex flex-col items-center space-y-6 pt-4",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-base font-black text-[#202020] md:text-lg",
        children: expertiseTitle
      }), /*#__PURE__*/_jsx(Box, {
        className: "flex w-full flex-row flex-wrap items-center justify-center gap-4",
        children: expertiseChips.map(function (item, index) {
          return /*#__PURE__*/_jsx(Box, {
            className: "rounded-full bg-[#006DB00A] px-6 py-3",
            children: /*#__PURE__*/_jsx(Typography, {
              className: "text-sm font-bold text-[#006DB0] md:text-lg",
              children: item.text
            })
          }, index);
        })
      })]
    })]
  });
};

export default IntroCoverageSection;